import { DisplayObject } from "@pixi/display";
import { createEnchantedFrameLoop } from "../createEnchantedFrameLoop";

export type EnchantableInstance = Pick<DisplayObject, "updateTransform" | "render" | "destroy">;

export function assignEnchantedFrameLoop<T extends EnchantableInstance>(target: T) {
  const onEnterFrame = createEnchantedFrameLoop(target);
  return Object.assign(target, { onEnterFrame });
}
